import { NgModule } from '@angular/core';
import { NkIfOnDomDirective } from './nk-if-on-dom.directive';
import {
  NkMatSidenavHelperDirective,
  NkMatSidenavTogglerDirective,
} from './nk-mat-sidenav.directive';

@NgModule({
  imports: [
    NkIfOnDomDirective,
    NkMatSidenavHelperDirective,
    NkMatSidenavTogglerDirective,
  ],
  exports: [
    NkIfOnDomDirective,
    NkMatSidenavHelperDirective,
    NkMatSidenavTogglerDirective,
  ],
})
export class NkDirectivesModule {}
